<ion-header class="ion-no-border white-header">
  <ion-toolbar fixed>
    <ion-buttons slot="start">
      <ion-button (click)="onDismiss()">
        <ion-icon src="/assets/custom-icons/b-times.svg"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>{{ vendor.name }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="onOpenMoreOptions()">
        <ion-icon class="more-button-icon" slot="icon-only" src="/assets/custom-icons/three-dots.svg"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div class="order-details">
    <div class="order-details-item">
      <div>{{ "ORDER_DETAILS_MODAL_PAGE.ORDER_ID" | translate }}</div>
      <div>{{ order.orderId }}</div>
      <span
        class="order-status"
        *ngIf="vendor.status.text"
        [style.color]="vendor.status.color"
        [style.backgroundColor]="vendor.status.backgroundColor"
      >
        {{ vendor.status.text }}
      </span>
    </div>

    <div class="order-details-item">
      <div>{{ "ORDER_DETAILS_MODAL_PAGE.STATUS" | translate }}</div>
      <div>{{ order.deliveryStatusText || order.statusText }}</div>
    </div>
    <div class="order-details-item">
      <div>{{ "ORDER_DETAILS_MODAL_PAGE.ORDER_DATE" | translate }}</div>
      <div>{{ order.submittedLtz | formatDateTime : { format: "DD MMM YYYY, h:mm A" } }}</div>
    </div>
    <div class="order-details-item">
      <div>{{ "ORDER_DETAILS_MODAL_PAGE.EVENT_DATE" | translate }}</div>
      <div>{{ vendor.deliveryDateFormatted }}</div>
    </div>
    <div class="order-details-item">
      <div>{{ "ORDER_DETAILS_MODAL_PAGE.DELIVERY_ADDRESS" | translate }}</div>
      <div>
        <app-address-details [plainText]="true" [hidePhoneNumber]="true" [address]="order.customer"></app-address-details>
      </div>
    </div>

    <div class="order-details-item">
      <div>{{ "FIELDS.PHONE" | translate }}</div>
      <div>{{ order.customer.phoneNumber }}</div>
    </div>

    <div *ngIf="order.transaction && order.transaction.paymentMethodText" class="order-details-item">
      <div>{{ "ORDER_DETAILS_MODAL_PAGE.PAYMENT_METHOD" | translate }}</div>
      <div>{{ order.transaction.paymentMethodText }}</div>
    </div>
  </div>

  <div class="vendor-items">
    <div
      class="vendor-item-details"
      [class.single-line]="!item?.options?.length && !item.addOns?.length && !item.specialRequests && !item.requiresFemaleServer"
      *ngFor="let item of vendor.menuItems"
    >
      <app-animated-image [imageUrl]="item.imageUrl"></app-animated-image>
      <div class="vendor-item-name">
        <p class="vendor-item-name-row">
          {{ item.name }} <span class="vendor-item-quantity">(x{{ item.quantity || item.stationQuantity }})</span>
        </p>

        <p class="vendor-item-name-row secondary" *ngFor="let option of item.options">{{ option.name }} (x{{ option.quantity }})</p>
        <p class="vendor-item-name-row secondary" *ngFor="let addon of item.addOns">{{ addon.name }} (x{{ addon.quantity }})</p>
        <p class="vendor-item-name-row secondary" *ngIf="item.requiresFemaleServer">
          {{ "ORDER_DETAILS_MODAL_PAGE.FEMALE_SERVICE_REQUESTED" | translate }}
        </p>
        <p class="vendor-item-name-row secondary" *ngIf="item.specialRequests">{{ item.specialRequests }}</p>
      </div>
      <div class="vendor-item-total">{{ item.totalBeforeDiscount | localCurrency }}</div>
    </div>
  </div>

  <div class="vendor-items">
    <div class="vendor-item-details vendor-subtotal">
      <div class="vendor-item-name">
        <p class="vendor-item-name-row">{{ "ORDER_DETAILS_MODAL_PAGE.SUBTOTAL" | translate }}</p>
      </div>
      <div class="vendor-item-total">{{ subtotal | localCurrency }}</div>
    </div>

    <div class="vendor-item-details delivery-charges">
      <div class="vendor-item-name">
        <p class="vendor-item-name-row">{{ "ORDER_DETAILS_MODAL_PAGE.DELIVERY_CHARGES" | translate }}</p>
      </div>
      <div class="vendor-item-total">{{ vendor.deliveryCharge ? (vendor.deliveryCharge | localCurrency) : ("FREE" | translate) }}</div>
    </div>

    <div class="vendor-item-details vendor-total">
      <div class="vendor-item-name">
        <p class="vendor-item-name-row">{{ "ORDER_DETAILS_MODAL_PAGE.TOTAL" | translate }} {{ vendor.name }}</p>
      </div>
      <div class="vendor-item-total">{{ total | localCurrency }}</div>
    </div>
  </div>
</ion-content>

<!-- This modal should look exactly the same on cordova and browsers -->
<ion-modal class="bottom-action-sheet" [isOpen]="isOrderOptionsModalOpen" (didDismiss)="onDismissOrderOptions()">
  <ng-template>
    <div class="inner-content">
      <div class="bottom-action-sheet-header">
        <p class="bottom-action-sheet-title">{{ "NEED_HELP" | translate }}</p>
        <p class="bottom-action-sheet-description">
          {{ "YOUR_ORDER_ID_IS" | translate }} <span class="bottom-action-sheet-highlighted">{{ order.orderId }}</span>
        </p>
      </div>

      <div class="bottom-action-sheet-body">
        <ion-button class="bottom-action-sheet-button bottom-action-sheet-highlighted" (click)="onReorder()" expand="block" color="green">
          {{ "REORDER" | translate }}
        </ion-button>

        <ion-button class="bottom-action-sheet-button" (click)="onCallUs()" expand="block" color="grey">
          {{ "CALL_US" | translate }}
        </ion-button>

        <ion-button class="bottom-action-sheet-button" (click)="onEmailUs()" expand="block" color="grey">
          {{ "EMAIL_US" | translate }}
        </ion-button>

        <ion-button *ngIf="isWhatsAppChatEnabled" class="bottom-action-sheet-button" (click)="onTextUs()" expand="block" color="grey">
          {{ "TEXT_US" | translate }}
        </ion-button>

        <ion-button
          *ngIf="order.isUpdatable"
          class="bottom-action-sheet-button"
          (click)="onOpenOrderUpdateModal()"
          expand="block"
          color="grey"
        >
          {{ "ORDER_DETAILS_MODAL_PAGE.UPDATE_ORDER" | translate }}
        </ion-button>

        <ion-button
          *ngIf="order.isReviewable && !wasReviewed"
          class="bottom-action-sheet-button"
          (click)="onOpenOrderReviewModal()"
          expand="block"
          color="grey"
        >
          {{ "ORDER_DETAILS_MODAL_PAGE.RATE_YOUR_ORDER" | translate }}
        </ion-button>

        <ion-button class="bottom-action-sheet-button" (click)="onShareOrder()" expand="block" color="grey">
          {{ "ORDER_DETAILS_MODAL_PAGE.INVITE_FRIENDS" | translate }}
        </ion-button>

        <ion-button
          *ngIf="order.isCancelable"
          class="danger bottom-action-sheet-button"
          (click)="onCancelOrder()"
          expand="block"
          color="grey"
        >
          {{ "ORDER_DETAILS_MODAL_PAGE.CANCEL_ORDER" | translate }}
        </ion-button>
      </div>
    </div>
  </ng-template>
</ion-modal>
